import { createApp } from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import axios from 'axios'
// import store from './store'
import { createPinia } from 'pinia'

// Library Components
import VueSweetalert2 from 'vue-sweetalert2'
import BootstrapVue3 from 'bootstrap-vue-3'
import CounterUp from '@/assets/vendor/vue3-autocounter'
import 'aos/dist/aos.css'
import '@/assets/css/relate-design-system.css'

// Custom Components & Directives
import globalComponent from './plugins/global-components'
import globalDirective from './plugins/global-directive'
import globalMixin from './plugins/global-mixin'
import { setupAxios } from './plugins/axios'
import './plugins/echo'

const app = createApp(App)
const pinia = createPinia()

app.use(pinia)
app.use(router)

// Инициализация Axios и глобальных перехватчиков 401 ошибок
setupAxios()

// Library Components
app.use(VueSweetalert2)
app.use(BootstrapVue3)
app.component('counter-up', CounterUp)

// Custom Components & Directives
app.use(globalComponent)
app.use(globalDirective)
app.mixin(globalMixin)

app.mount('#app')

export default app
